import { P } from 'components'
import BreadCrumbs from 'components/breadcrumbs'
import { ResponsiveActionButton } from 'components/Buttons'
import CustomButton from 'components/Buttons/CustomButton'
import LihatDetail from 'components/Icons/LihatDetail'
import PMBPagination from 'components/PMBPagination'
import PMBSelect from 'components/PMBSelect'
import ProfilePic from 'components/PMBProfilePic'
import { TableComponent as DataTable } from 'components/TableComponent'
import { Can } from 'context/Acl'
import debounce from 'lodash.debounce'
import { useCallback, useEffect, useMemo, useState } from 'react'
import {
  ArrowLeft,
  ArrowRightCircle,
  CheckCircle,
  ChevronDown,
  Plus,
  Search,
  Repeat,
  Download,
  Filter,
  ChevronUp,
} from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { handleDownloadCSV, handleDownloadExcel } from './downloadStaff'
import {
  Alert,
  Badge,
  Card,
  CardBody,
  CardText,
  Col,
  Collapse,
  FormGroup,
  Input,
  InputGroupText,
  Row,
  Spinner,
  UncontrolledTooltip,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap'
import { BUSINESS_COMPANY, MANAGE } from 'utils/subjectActions'
import TabManageStaffGroup from '../components/TabManageStaffGroup'
import {
  useFetchFarmersV2Query,
  useFetchSummaryFarmerQuery,
  useLazyFetchFarmersV2Query,
} from '../farmers-list/farmersListApiSlice'
import { clearState } from '../forms/formSlice'
import { getGroupList } from '../groups-list/groupListAction'
import ModalChangeRole from './ModalChangeRole'
import ModalTransferStaff from './ModalTransferStaff'
import ModalDeleteStaff from './ModalDeleteStaff'
import {
  useFetchSharedGroupFarmersQuery,
  useFetchSharedGroupFarmerSummaryQuery,
  useFetchSharedGroupManagementQuery,
  useLazyFetchSharedGroupFarmersQuery,
} from '../shared-farmers/sharedFarmersApiSlice'
import { setFetchOption, toggleBanner, toggleModal } from './staffListSlice'
import { PMBDateRangePicker } from 'components/PMBNewDatePicker'
import moment from 'moment-timezone'
import SvgIcon from 'components/Icon/SvgIcon'

const defaultGroupFilter = {
  id: 0,
  name: 'Semua Grup',
  value: 'Semua Grup',
  label: 'Semua Grup',
}

const optionStatus = [
  {
    label: 'Semua Status',
    value: undefined,
  },
  {
    label: 'Pending',
    value: 'PENDING',
  },
  {
    label: 'Disetujui',
    value: 'APPROVED',
  },
  {
    label: 'Dibuat',
    value: 'CREATED',
  },
]

const optionStatus2 = [
  {
    label: 'Semua Status',
    value: undefined,
  },
  {
    label: 'Belum Terverifikasi',
    value: 'UNVERIFIED',
  },
  {
    label: 'Menunggu Verifikasi',
    value: 'WAITAPPROVAL',
  },
  {
    label: 'Terverifikasi',
    value: 'VERIFIED',
  },
]

const StaffList = ({ sharedResourceId, sharedOwnerName, onBackToSharedGroups }) => {
  const isShared = Boolean(sharedResourceId)
  const { tag: ownTag, isOpenBanner } = useSelector((s) => s.staffList)
  const [sharedTag, setSharedTag] = useState({ page: 0, size: 10 })
  const tag = isShared ? sharedTag : ownTag
  const { ownerData } = useSelector((s) => s.dashboard)
  const { loading, bannerMsg, groups, allGroupCount } = useSelector(
    (s) => s.groupsList,
  )

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const updateFetchOptions = (updates) => {
    if (isShared) setSharedTag((current) => ({ ...current, ...updates }))
    else dispatch(setFetchOption(updates))
  }

  let [page, setPage] = useState({ page: tag.page })
  const [selectedRow, setSelectedRow] = useState(null)
  const [isOpenTransfer, setIsOpenTransfer] = useState(false)
  const [isOpenDelete, setIsOpenDelete] = useState(false)
  const [isDownloading, setIsDownloading] = useState(false)
  const [triggerFetchFarmersV2] = useLazyFetchFarmersV2Query()

  const [showFilterByGroup, setShowFilterByGroup] = useState(false)
  const [selectedGroupFilter, setSelectedGroupFilter] =
    useState(defaultGroupFilter)
  const [currentSortColumn, setCurrentSortColumn] = useState()
  const [currentSortDirection, setCurrentSortDirection] = useState()
  const [isShowFilter, setIsShowFilter] = useState(false)
  const [searchValue, setSearchValue] = useState(tag?.search ?? '')
  const activeFilterCount = useMemo(() => {
    let count = 0
    if (tag?.status) count++
    if (tag?.vpstatus) count++
    if (tag?.search) count++
    if (tag?.startdate && tag?.enddate) count++
    if (tag?.groupCode) count++
    return count
  }, [tag])

  const {
    data: ownJoin,
    isLoading: isLoadingOwnJoin,
    refetch: refetchOwnJoin,
  } = useFetchFarmersV2Query(
    {
      sortby: currentSortColumn,
      sortdir: currentSortDirection,
      ...tag,
    },
    { skip: !page || isShared },
  )

  const {
    data: ownSummary,
    isLoading: isLoadingSummary,
    refetch: refetchSummary,
  } = useFetchSummaryFarmerQuery({}, { skip: !page || isShared })

  const {
    data: ownPending,
    isLoading: isLoadingPending,
    refetch: refetchPending,
  } = useFetchFarmersV2Query(
    {
      size: tag?.size,
      page: tag?.page,
      status: 'PENDING',
    },
    { skip: !page || isShared },
  )

  const { data: sharedJoin, isLoading: isLoadingSharedJoin } =
    useFetchSharedGroupFarmersQuery(
      {
        resourceId: sharedResourceId,
        sortby: currentSortColumn,
        sortdir: currentSortDirection,
        ...tag,
      },
      { skip: !isShared },
    )
  const { data: sharedSummary } = useFetchSharedGroupFarmerSummaryQuery(
    { resourceId: sharedResourceId, groupCode: tag?.groupCode },
    { skip: !isShared },
  )
  const { data: sharedPending } = useFetchSharedGroupFarmersQuery(
    { resourceId: sharedResourceId, page: 0, size: 1, status: 'PENDING' },
    { skip: !isShared },
  )
  const { data: sharedGroups } = useFetchSharedGroupManagementQuery(
    { resourceId: sharedResourceId, page: 0, size: 100 },
    { skip: !isShared },
  )
  const [triggerFetchSharedFarmers] = useLazyFetchSharedGroupFarmersQuery()
  const triggerDownload = isShared
    ? (params) => triggerFetchSharedFarmers({ ...params, resourceId: sharedResourceId })
    : triggerFetchFarmersV2
  const dataJoin = isShared ? sharedJoin : ownJoin
  const dataSummary = isShared ? sharedSummary : ownSummary
  const dataPending = isShared ? sharedPending : ownPending
  const availableGroups = isShared ? sharedGroups?.items : groups?.items
  const isLoadingJoin = isShared ? isLoadingSharedJoin : isLoadingOwnJoin
  const refetchJoin = isShared ? () => {} : refetchOwnJoin

  const columns = [
    {
      name: <span>Nama Anggota</span>,
      selector: 'name',
      exportValue: (row) => row?.name || '-',
      grow: 3,
      sortable: true,
      cell: (row) => {
        const hasSubInfo = (row?.partnershipName && row?.partnershipName !== row?.name) || (row?.partnershipAccountName && row?.partnershipAccountName !== row?.name)
        return (
        <div className={`d-flex ${hasSubInfo ? 'align-items-start' : 'align-items-center'} gap-2 py-2`}>
          <ProfilePic
            imgSrc={row?.profilePic}
            altText={row?.name}
            name={row?.name}
            avatarSeed={row?.userId}
            width={28}
            height={28}
          />

          <div
            className="d-flex flex-column"
            style={{
              minWidth: 0,
              lineHeight: '1.3',
            }}
          >
            <span
              className="fw-medium"
              style={{
                wordBreak: 'break-word',
              }}
            >
              {row?.name || '-'}
            </span>

            {(row?.partnershipName || row?.partnershipAccountName) && (
              <div
                className="d-flex flex-column"
                style={{ marginTop: '2px' }}
              >
                {row?.partnershipAccountName && row?.partnershipAccountName !== row?.name && (
                  <small
                    className="text-muted"
                    style={{
                      fontSize: '0.7rem',
                      lineHeight: '1.2',
                      wordBreak: 'break-word',
                    }}
                  >
                    PIC: {row.partnershipAccountName}
                  </small>
                )}
                {row?.partnershipName && row?.partnershipName !== row?.name && (
                  <span
                    className="text-primary fw-semibold"
                    style={{
                      fontSize: '0.8rem',
                      wordBreak: 'break-word',
                    }}
                  >
                    {row.partnershipName}
                  </span>
                )}
              </div>
            )}
          </div>
        </div>
      )},
    },
    {
      name: <span>Identitas</span>,
      selector: 'phoneNumber',
      exportValue: (row) => row?.phoneNumber || '-',
      grow: 2,
      minWidth: '150px',
      cell: (row) => <span>{row?.phoneNumber}</span>,
    },
    {
      name: <span>Grup</span>,
      selector: 'groupName',
      exportValue: (row) => row?.groupName || '-',
      grow: 2,
      sortable: true,
      minWidth: '150px',
      cell: (row) => <span>{row?.groupName}</span>,
    },
    {
      name: 'Status',
      selector: 'vpStatus',
      sortable: true,
      minWidth: '150px',
      exportValue: (row) => {
        if (row?.vpStatus === 'VERIFIED') return 'Terverifikasi'
        if (row?.vpStatus === 'WAITAPPROVAL') return 'Menunggu Verifikasi'
        return 'Belum Terverifikasi'
      },
      cell: (row) => (
        <span
          onClick={() => {
            if (isShared) return
            dispatch(toggleModal())
            setSelectedRow(row)
          }}
          style={{
            textAlign: 'center',
            cursor: isShared ? 'default' : 'pointer',
            color: row?.vpStatus === 'VERIFIED' ? '#027A48' : '#B42318',
            paddingRight: 10,
            paddingLeft: 10,
            paddingTop: 5,
            paddingBottom: 5,
            borderRadius: 99,
            backgroundColor:
              row?.vpStatus === 'VERIFIED' ? '#ECFDF3' : '#FEF3F2',
          }}
        >
          <P size="small" bold>
            {row?.vpStatus === 'VERIFIED'
              ? 'Terverifikasi'
              : row?.vpStatus === 'WAITAPPROVAL'
                ? 'Menunggu Verifikasi'
                : 'Belum Terverifikasi'}
          </P>
        </span>
      ),
    },
    {
      name: <span>Keanggotaan</span>,
      selector: 'status',
      grow: 2,
      sortable: true,
      minWidth: '150px',
      exportValue: (row) => {
        if (row?.status === 'APPROVED') return 'Disetujui'
        if (row?.status === 'PENDING') return 'Pending'
        return 'Dibuat'
      },
      cell: (row) => (
        <div
          className={
            'badge rounded-pill font-semibold mt-2' +
            (row?.status === 'APPROVED'
              ? ' bg-success-50 text-success'
              : row?.status === 'PENDING'
                ? ' bg-warning-50 text-warning-700'
                : ' text-primary bg-primary-50')
          }
          style={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            textAlign: 'center',
            maxWidth: '100%',
          }}
        >
          {row?.status === 'APPROVED'
            ? 'Disetujui'
            : row?.status === 'PENDING'
              ? 'Pending'
              : 'Dibuat'}
        </div>
      ),
    },
    {
      skipExport: true,
      cell: (row) => (
        <div
          className="d-flex gap-2 align-items-center"
          data-testid={`farmer-member-row-${row?.userId}`}
        >
          {isShared ? (
            <LihatDetail
              onClick={() => navigate(`/farmers/${row?.userId}?resourceId=${sharedResourceId}`)}
              id={row?.id}
              testId={`shared-farmer-member-detail-${row?.userId}`}
            />
          ) : (
          <Can I={MANAGE} this={BUSINESS_COMPANY}>
            <LihatDetail
              onClick={() => navigate(`/farmers/${row?.userId}`)}
              id={row?.id}
              style={{ cursor: 'pointer' }}
              data-testid={`farmer-member-detail-${row?.userId}`}
            />
            <span
              id={`transfer-tooltip-${row?.id}`}
              onClick={() => {
                setSelectedRow(row)
                setIsOpenTransfer(true)
              }}
              style={{ cursor: 'pointer' }}
              data-testid={`farmer-member-transfer-${row?.userId}`}
            >
              <Repeat size={18} />
            </span>
            <UncontrolledTooltip target={`transfer-tooltip-${row?.id}`}>
              Transfer Anggota
            </UncontrolledTooltip>
            <ResponsiveActionButton
              iconName="trash"
              label="Hapus Anggota"
              iconColor="danger"
              onClick={() => {
                setSelectedRow(row)
                setIsOpenDelete(true)
              }}
              testId={`farmer-member-delete-${row?.userId}`}
            />
          </Can>
          )}
        </div>
      ),
    },
  ]

  const debouncedSearch = useCallback(
    debounce((value) => {
      updateFetchOptions({ search: value || undefined, page: 0 })
    }, 400),
    [],
  )

  const handleSearchChange = (e) => {
    const value = e.target.value
    setSearchValue(value)
    debouncedSearch(value)
  }

  const handleFinishedChangeRole = () => {
    dispatch(toggleBanner())
    refetchJoin()
  }

  const handleSort = (column, direction) => {
    const sortColumn = column?.selector
    const sortDirection = direction?.toLowerCase() === 'asc' ? 'ASC' : 'DESC'

    setCurrentSortColumn(sortColumn)
    setCurrentSortDirection(sortDirection)
  }

  const handleResetFilter = () => {
    setSearchValue('')
    debouncedSearch.cancel()
    updateFetchOptions({
        status: undefined,
        vpstatus: undefined,
        search: undefined,
        startdate: undefined,
        enddate: undefined,
        page: 0,
        groupCode: undefined,
      })
  }

  const customStyles = {
    headCells: {
      style: {
        color: '#667085',
        backgroundColor: '#F9FAFB',
      },
    },
    cells: {
      style: {},
    },
    rows: {
      style: {},
    },
  }

  useEffect(() => {
    if (!isShared) dispatch(getGroupList({}))
  }, [dispatch, isShared])

  useEffect(() => {
    dispatch(clearState())
  }, [])

  return (
    <div className="w-100 px-3">
      <div className="d-flex align-items-start gap-2 pt-3">
        <BreadCrumbs
          breadCrumbActive={isShared ? sharedOwnerName || 'Anggota Bersama' : 'Daftar Anggota'}
          breadCrumbParent={isShared ? 'Daftar Anggota Bersama' : undefined}
          breadCrumbParentLink={isShared ? '/farmers/shared' : '/farmers'}
        />
      </div>
      {!isShared && <ModalChangeRole
        isSubGroup={true}
        row={selectedRow}
        handleFinishedChangeRole={handleFinishedChangeRole}
      />}
      {!isShared && <ModalTransferStaff
        isOpen={isOpenTransfer}
        toggle={() => setIsOpenTransfer(!isOpenTransfer)}
        selectedRow={selectedRow}
        onSuccess={() => refetchJoin()}
      />}
      {!isShared && <ModalDeleteStaff
        isOpen={isOpenDelete}
        toggle={() => setIsOpenDelete(!isOpenDelete)}
        selectedRow={selectedRow}
        onSuccess={() => refetchJoin()}
      />}
      <Card className="border-0 shadow-sm">
        <CardBody>
          <DataTable
            customStyles={customStyles}
            columns={columns}
            data={dataJoin?.items}
            // selectableRows
            onSort={handleSort}
            // onSelectedRowsChange={(e) => console.log(e)}
            progressPending={isLoadingJoin}
            responsive
            persistTableHead
            progressComponent={<Spinner />}
            sortIcon={<ChevronDown />}
            sortServer
            className="border p-0 border-1 rounded-top"
            noDataComponent={
              <p className="my-3 fw-semibold">
                Belum ada pengguna yang didaftarkan
              </p>
            }
            pagination
            paginationServer
            paginationComponent={(props) => (
              <PMBPagination
                rowCount={dataJoin?.totalItems}
                currentPage={tag?.page}
                rowsPerPage={tag?.size ?? 10}
                setCurrentPage={(e) => {
                  updateFetchOptions({ page: e })
                }}
                setRowsPerPage={(e) => {
                  updateFetchOptions({ size: e })
                }}
                props={props}
                testId="farmer-member-pagination"
              />
            )}
            subHeader={true}
            subHeaderComponent={
              <div className="w-100">
                <TabManageStaffGroup />
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="d-flex flex-column align-items-start gap-2">
                    {isShared && (
                      <button
                        type="button"
                        className="btn btn-link text-decoration-none p-0 d-inline-flex align-items-center gap-1 fw-semibold"
                        onClick={onBackToSharedGroups}
                      >
                        <ArrowLeft size={16} /> Kembali ke Grup yang Dibagikan
                      </button>
                    )}
                    {isLoadingJoin ? (
                      <Spinner color="primary" />
                    ) : (
                      <h5 className="fw-semibold mb-0">
                        {isShared ? `Daftar Anggota ${sharedOwnerName || ''}` : 'Daftar Anggota'}
                      </h5>
                    )}
                  </div>
                  {!isShared && <div>
                    <CustomButton
                      className="d-flex align-items-center gap-1"
                      color="primary"
                      onClick={() => {
                        navigate('/farmers/check', {
                          state: { name: 'Daftar Anggota' },
                        })
                      }}
                      testId="farmer-add-member-button"
                    >
                      <Plus size={14} />
                      <P size="regular">Tambah Anggota</P>
                    </CustomButton>
                  </div>}
                </div>
                <Row>
                  {dataPending?.totalItems ? (
                    <Col lg="2" md="6" sm="12" className="d-flex mb-4">
                      <Card
                        onClick={() => isShared
                          ? updateFetchOptions({ status: 'PENDING', page: 0 })
                          : navigate('/farmers/pending')}
                        body
                        style={{ cursor: 'pointer' }}
                        className="w-100 border-0 shadow-sm"
                        data-testid="farmer-pending-card"
                      >
                        <CardText tag="small" className="fw-semibold">
                          Menunggu Konfirmasi
                        </CardText>
                        <div className="d-flex justify-content-between align-items-center mt-2">
                          <div className="text-primary h3">
                            {dataPending?.totalItems}
                          </div>
                          <div>
                            <ArrowRightCircle size={20} />
                          </div>
                        </div>
                      </Card>
                    </Col>
                  ) : null}

                  <Col lg="2" md="6" sm="12" className="d-flex mb-4">
                    <Card body className="w-100 border-0 shadow-sm">
                      <CardText tag="small" className="fw-semibold">
                        Total Anggota
                      </CardText>
                      <div className="d-flex justify-content-between align-items-center mt-2">
                        <div className="text-primary h3">
                          {dataSummary?.totalMember ?? 0}
                        </div>
                      </div>
                    </Card>
                  </Col>
                  <Col lg="2" md="6" sm="12" className="d-flex mb-4">
                    <Card body className="w-100 border-0 shadow-sm">
                      <CardText tag="small" className="fw-semibold">
                        Anggota Terverifikasi
                      </CardText>
                      <div className="d-flex justify-content-between align-items-center mt-2">
                        <div className="text-primary h3">
                          {dataSummary?.totalVerifiedMember ?? 0}
                        </div>
                      </div>
                    </Card>
                  </Col>
                  <Col lg="2" md="6" sm="12" className="d-flex mb-4">
                    <Card body className="w-100 border-0 shadow-sm">
                      <CardText tag="small" className="fw-semibold">
                        Anggota Belum Terverifikasi
                      </CardText>
                      <div className="d-flex justify-content-between align-items-center mt-2">
                        <div className="text-primary h3">
                          {dataSummary?.totalUnverifiedMember ?? 0}
                        </div>
                      </div>
                    </Card>
                  </Col>
                </Row>

                <div className="d-flex gap-2 justify-content-end mb-3">
                  {activeFilterCount > 0 && (
                    <CustomButton
                      onClick={handleResetFilter}
                      color="danger"
                      className="d-flex align-items-center justify-content-center"
                      style={{
                        width: '40px',
                        height: '40px',
                        padding: 0,
                        minWidth: '40px',
                      }}
                      testId="farmer-filter-reset-button"
                    >
                      <SvgIcon name="x" size={16} color="white" />
                    </CustomButton>
                  )}

                  <CustomButton
                    onClick={() => setIsShowFilter((prev) => !prev)}
                    color="primary"
                    outline
                    className="position-relative"
                    testId="farmer-filter-toggle-button"
                  >
                    <div className="d-flex align-items-center gap-2 justify-content-center">
                      <Filter size={15} />
                      <P>Filter</P>
                      {activeFilterCount > 0 && (
                        <Badge
                          color="danger"
                          pill
                          style={{
                            position: 'absolute',
                            top: '-5px',
                            right: '-5px',
                            fontSize: '10px',
                          }}
                        >
                          {activeFilterCount}
                        </Badge>
                      )}
                      {isShowFilter ? (
                        <ChevronUp size={16} />
                      ) : (
                        <ChevronDown size={16} />
                      )}
                    </div>
                  </CustomButton>

                  <UncontrolledDropdown>
                    <DropdownToggle
                      color="primary"
                      outline
                      disabled={isDownloading}
                      data-testid="farmer-download-button"
                    >
                      <div className="d-flex justify-content-center align-items-center gap-2">
                        {isDownloading ? (
                          <Spinner size="sm" />
                        ) : (
                          <Download size={15} />
                        )}
                        <span>
                          {isDownloading ? 'Downloading...' : 'Download'}
                        </span>
                      </div>
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem
                        onClick={() => {
                          handleDownloadExcel(
                            triggerDownload,
                            { ...tag },
                            setIsDownloading,
                            columns,
                          )
                        }}
                        data-testid="farmer-download-excel-button"
                      >
                        Excel
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => {
                          handleDownloadCSV(
                            triggerDownload,
                            { ...tag },
                            setIsDownloading,
                            columns,
                          )
                        }}
                        data-testid="farmer-download-csv-button"
                      >
                        CSV
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>

                <Collapse isOpen={isShowFilter} className="mt-3">
                  <div className="border rounded p-3 bg-light mb-3">
                    <Row>
                      <Col lg="3" md="4" sm="12" className="mb-3">
                        <p className="mb-2">Cari Anggota</p>
                        <FormGroup className="d-flex border rounded">
                          <Input
                            placeholder="Cari anggota..."
                            onChange={handleSearchChange}
                            style={{ border: 'none', boxShadow: 'none' }}
                            value={searchValue}
                            data-testid="farmer-search-input"
                          />
                          <InputGroupText
                            style={{
                              backgroundColor: '#ffffff',
                              border: 'none',
                            }}
                          >
                            <Search size={15} style={{ cursor: 'pointer' }} />
                          </InputGroupText>
                        </FormGroup>
                      </Col>

                      <Col lg="3" md="4" sm="12" className="mb-3">
                        <PMBDateRangePicker
                          style={{ width: '100%', maxWidth: '100%' }}
                          data-testid="farmer-filter-date-select"
                          value={[
                            tag?.startdate
                              ? moment(tag.startdate).toDate()
                              : null,
                            tag?.enddate ? moment(tag?.enddate).toDate() : null,
                          ]}
                          onChange={(dates) => {
                            if (dates && dates[0] && dates[1]) {
                              const [startStr, endStr] = dates
                              const start = moment(startStr)
                                .startOf('day')
                                .toISOString()
                              const end = moment(endStr)
                                .endOf('day')
                                .toISOString()

                              const prevFromStr = tag?.startdate
                                ? moment(tag.startdate)
                                  .startOf('day')
                                  .format('YYYY-MM-DD')
                                : null
                              const prevToStr = tag?.enddate
                                ? moment(tag?.enddate)
                                  .startOf('day')
                                  .format('YYYY-MM-DD')
                                : null

                              if (
                                prevFromStr === startStr &&
                                prevToStr === endStr
                              )
                                return
                              updateFetchOptions({
                                  startdate: start,
                                  enddate: end,
                                  page: 0,
                                })
                            }
                          }}
                          slotProps={{
                            textField: {
                              size: 'small',
                            },
                          }}
                          onClear={() => {
                            updateFetchOptions({
                                startdate: undefined,
                                enddate: undefined,
                                page: 0,
                              })
                          }}
                        />
                      </Col>

                      <Col lg="3" md="4" sm="12" className="mb-3">
                        <p className="mb-2">Grup</p>
                        <PMBSelect
                          style={{ cursor: 'pointer' }}
                          placeholder="Semua Grup"
                          options={[
                            defaultGroupFilter,
                            ...(availableGroups || []),
                          ]?.map((el) => ({
                            ...el,
                            label: el?.name,
                            value: el?.name,
                          }))}
                          testId="farmer-filter-group-select"
                          onChange={(e) => {
                            updateFetchOptions({ groupCode: e.code, page: 0 })
                          }}
                          value={
                            availableGroups?.find(
                              (e) => e.code === tag?.groupCode,
                            )
                              ? {
                                label: availableGroups?.find(
                                  (e) => e.code === tag?.groupCode,
                                )?.name,
                                code: tag?.groupCode,
                              }
                              : defaultGroupFilter
                          }
                        />
                      </Col>

                      <Col lg="3" md="4" sm="12" className="mb-3">
                        <p className="mb-2">Status</p>
                        <PMBSelect
                          style={{ cursor: 'pointer' }}
                          placeholder="Semua Status"
                          options={optionStatus2}
                          testId="farmer-filter-status-select"
                          onChange={(e) => {
                            updateFetchOptions({ vpstatus: e.value, page: 0 })
                          }}
                          value={optionStatus2?.find(
                            (e) => e.value === tag?.vpstatus,
                          )}
                        />
                      </Col>

                      <Col lg="3" md="4" sm="12" className="mb-3">
                        <p className="mb-2">Keanggotaan</p>
                        <PMBSelect
                          style={{ cursor: 'pointer' }}
                          placeholder="Semua Keanggotaan"
                          options={optionStatus}
                          testId="farmer-filter-membership-select"
                          onChange={(e) => {
                            updateFetchOptions({ status: e.value, page: 0 })
                          }}
                          value={optionStatus?.find(
                            (e) => e.value === tag?.status,
                          )}
                        />
                      </Col>
                    </Row>
                  </div>
                </Collapse>

                <div>
                  <Alert
                    isOpen={isOpenBanner}
                    toggle={() => dispatch(toggleBanner())}
                    color="success"
                    className="d-flex align-items-center mt-4 w-100"
                  >
                    <span>
                      <CheckCircle size={17} /> Peran berhasil diubah.
                    </span>
                  </Alert>
                </div>
              </div>
            }
          />
        </CardBody>
      </Card>
    </div>
  )
}

export default StaffList
